<template>
  <div class="account_settings mobile_phone_binding">
    <!-- 标题 -->
    <!-- <div class="tit">
      <span>手机绑定</span>
    </div> -->
    <!-- content -->
    <div class="content body_content">
      <el-row v-if="bindMobile">
        <el-col class="right-content">
          <el-steps :active="mobileActive" align-center finish-status="success">
            <el-step title="验证原手机"></el-step>
            <el-step title="绑定新手机"></el-step>
            <el-step title="完成绑定"></el-step>
          </el-steps>
        </el-col>
      </el-row>
      <el-row>
        <el-col v-if="!bindMobile">
          您已绑定的手机号码是
          <span style="color: #FF733C">{{params.mobileMask}}</span>
          <el-button class="ml20" type="primary" @click="bindMobile=true" plain>修改号码</el-button>
        </el-col>
        <!-- 第一步 验证手机号-->
        <el-col v-else-if="bindMobile && mobileActive===0" v-cloak>
          <el-form
            :model="params"
            ref="ruleForm1"
            status-icon
            :rules="rules1"
            label-width="120px"
            label-position="left"
          >
            <el-form-item label="原手机号:" prop="mobile">
              <div>{{params.mobileMask}}</div>
            </el-form-item>
            <el-form-item label="验证码:" prop="mobileCode">
              <el-input class="input-width" placeholder="请输入验证码" v-model="params.mobileCode"></el-input>
              <el-button class="ml20" type="primary" @click="getCode">{{captchaText}}</el-button>
            </el-form-item>
            <el-form-item>
              <el-button class="notarize" type="primary" @click="step(1)">下一步</el-button>
            </el-form-item>
          </el-form>
        </el-col>
        <!-- 第二步 绑定手机号 -->
        <el-col v-else-if="bindMobile && mobileActive===1" v-cloak>
          <el-form
            :model="paramsNew"
            ref="ruleForm2"
            status-icon
            :rules="rules2"
            label-width="120px"
            label-position="left"
          >
            <el-form-item label="新手机号码:" prop="mobile">
              <el-input placeholder="请输入新手机号码" maxlength="11" v-model="paramsNew.mobile"></el-input>
            </el-form-item>
            <el-form-item label="验证码:" prop="mobileCode">
              <el-input placeholder="请输入验证码" class="code" v-model="paramsNew.mobileCode"></el-input>
              <el-button @click="getCode">{{captchaText}}</el-button>
            </el-form-item>
            <el-form-item>
              <el-button class="notarize" type="primary" @click="step(2)">下一步</el-button>
            </el-form-item>
          </el-form>
        </el-col>
        <el-col v-else-if="bindMobile && mobileActive===3">
          <div class="stepSuccess">
            <i class="el-icon-success"></i>
            <div>绑定成功</div>
          </div>
        </el-col>
      </el-row>
      <yzm_alert :yzmObj="yzmObj" v-on:setDwoncountSwitch="downcoutStart"></yzm_alert>
    </div>
  </div>
</template>

<script>
import yzm_alert from "@/components/yzm_alert/yzm_alert";
export default {
  components: {
    yzm_alert
  },
  data() {
    let validateMobile = (rule, value, callback) => {
      if (!value) {
        callback(new Error("请输入手机号"));
      } else {
        if (!/^1[345789]\d{9}$/.test(value)) {
          callback(new Error("手机号格式有误"));
        } else {
          callback();
        }
      }
    };
    return {
      defaultActive: "2-2",
      params: {
        mobile: "",
        mobileCode: ""
      },
      paramsNew: {
        mobile: "",
        mobileCode: ""
      },
      yzmObj: {
        mobile: "",
        dialogVisible: false,
        type: "MobileCodeTypeAuthentication"
      },
      rules1: {
        mobile: [{ required: true, trigger: "blur" }],
        mobileCode: [
          { required: true, message: "请输入短信验证码", trigger: "blur" }
        ]
      },
      rules2: {
        mobile: [
          { required: true, validator: validateMobile, trigger: "blur" }
        ],
        mobileCode: [
          { required: true, message: "请输入短信验证码", trigger: "blur" }
        ]
      },
      bindMobile: false,
      sendCaptchaTime: 60,
      captchaText: "获取验证码",
      getCodeInterval: null,
      downcount: false,
      mobileActive: 0 //步骤位置
    };
  },
  computed: {
    info() {
      return this.$store.state.info;
    }
  },
  created() {
    if (this.$store.state.info) {
      this.getParam();
    } else {
      this.needInfo("getParam");
    }
  },
  methods: {
    /* 监测个人信息 */
    needInfo(fn) {
      let watchAch = this.$watch("info", (val, oldVal) => {
        if (val) {
          this[fn]();
          watchAch(); //取消监听
        }
      });
    },
    getParam() {
      let info = this.$store.state.info;
      this.$set(this.params, "mobile", info.mobile);
      this.$set(
        this.params,
        "mobileMask",
        info.mobile.substring(0, 3) +
          "****" +
          info.mobile.substring(7, info.mobile.length)
      );
    },
    /**打开图片验证码对话框*/
    getCode: function() {
      if (!this.downcount) {
        if (
          this.mobileActive === 1 &&
          !/^1[345789]\d{9}$/.test(this.paramsNew.mobile)
        ) {
          this.$message("手机号格式有误");
          return;
        }
        this.yzmObj.mobile =
          this.mobileActive === 0 ? this.params.mobile : this.paramsNew.mobile;
        this.yzmObj.dialogVisible = true;
      }
    },
    /*** 发送验证码切换倒计时* */
    downcoutStart(data) {
      if (data) {
        clearInterval(this.getCodeInterval);
        this.downcount = true;
        this.sendCaptchaTime = 60;
        this.getCodeInterval = setInterval(() => {
          this.sendCaptchaTime--;
          this.captchaText = "验证码(" + this.sendCaptchaTime + ")s";
          if (this.sendCaptchaTime === 0) {
            this.captchaText = "获取验证码";
            this.downcount = false;
            clearInterval(this.getCodeInterval);
          }
        }, 1000);
      }
    },
    /** 提交步骤 */
    step: function(num) {
		//步骤1 验证旧手机
      if (num === 1) {
        if (!this.params.mobileCode) {
          this.$message("请获取并输入验证码");
          return;
        }
        this.api.verifyOldMobile(this.params).then(res => {
          if (res.error.err_code !== 0) return;
          this.mobileActive = num;
          this.captchaText = "获取验证码";
          this.sendCaptchaTime = 60;
          this.downcount = false;
          window.clearInterval(this.getCodeInterval);
        });
      } else if (num === 2) { //步骤二 绑定新手机
        if (!this.paramsNew.mobileCode) {
          this.$message("请获取并输入验证码");
          return;
        }
        this.$refs.ruleForm2.validate(valid => {
          if (valid) {
            this.api.modifyMobile(this.paramsNew).then(res => {
              if (res.error.err_code === 0) {
                this.mobileActive = 3;
              }
            });
          }
        });
      }
    }
  }
};
</script>

<style lang="scss">
// @import "../index.scss";

/*手机绑定*/
.content {
    height: 545px;
}
</style>
